export default "__VITE_ASSET__2b478f30__"